// import useClientCredentials from "./useClientCredentials"

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getScheduledTasksByClientId } from '../redux/actions/tasks';
import { StoreState } from '../types/state';

const useClientTasks = (id: string) => {
  const tasks = useSelector((state: StoreState) => {
    const taskIds = state.tasks.clientTasks[id];
    if (!taskIds) return taskIds;
    const tasks = taskIds.map((id: string) => {
      return state.tasks.scheduledTasks[id];
    });
    return tasks;
  });
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!tasks) {
      setIsLoading(true);
      dispatch(getScheduledTasksByClientId(id));
    } else setIsLoading(false);
  }, [id, tasks, dispatch]);

  return { tasks, isLoading };
};

export default useClientTasks;
